// @flow

import { routerConfigs } from '@gandi/redux-sharing';
import client from '@gandi/app-runner/esm/client';

import globals from './globals';
import reducers from './src/reducers';
import routes from './src/routes';


client({
  anonymousSupport: true,
  globals,
  reducers,
  routerConfig: routerConfigs.client,
  routes,
});
